import React from "react";
import "./Percentage.css";
import CountUp from 'react-countup';

const StatsSection = () => {
  const stats = [
    {
      value: 12,
      suffix: "+ Experience",
      description: "More than 12 years of Experience",
    },
    {
      value: 0,
      suffix: "Vision",
      description: "To be Hamilton’s most trusted and innovative automotive workshop, known for exceptional service, integrity, and a commitment to keeping our community safely on the road.",
    },
    {
      value: 0,
      suffix: "Mission",
      description: "At Ezer Automotive, our mission is to deliver high-quality, reliable automotive services with honesty, expertise, and care. We are dedicated to building long-term relationships with our customers through transparent communication, modern diagnostics, and a passion for automotive excellence.",
    },
    {
      value: 0,
      suffix: "Customer Delight",
      description: "Delivering 99% customer delight through exceptional service and care.",
    },
  ];

  return (
    <div className="stats-section">
      {stats.map((item, index) => (
        <div className="stat-box" key={index}>
          {/* <div className="stat-value chakra-petch-bold">
            <CountUp
              start={0}
              end={item.value}
              duration={2}
              suffix={item.suffix}
            />
          </div> */}
          <div className="stat-value chakra-petch-bold">
            {item.value !== 0 ? (
              <CountUp
                start={0}
                end={item.value}
                duration={2}
                suffix={item.suffix}
              />
            ) : (
              <span>{item.suffix}</span>
            )}
          </div>
          <div className="stat-line" />
          <div className="stat-description font-mulish">{item.description}</div>
        </div>
      ))}
    </div>
  );
};

export default StatsSection;
